import DashboardTemplate from './DashboardTemplate';
import { Building2 } from 'lucide-react';

const BrokerageDashboard = () => {
  return (
    <DashboardTemplate
      functionType="brokerage"
      title="Brokerage"
      subtitle="Premium, Revenue, Retention & Account Metrics"
      icon={Building2}
    />
  );
};

export default BrokerageDashboard;
